// extracted by mini-css-extract-plugin
module.exports = {"navbar":"section-nav_navbar__nIMVJ"};